"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_FEEDS_KEY = exports.DATA_FEED_ID_BS = exports.SIGNATURE_BS = exports.REDSTONE_MARKER_BS = exports.REDSTONE_MARKER_HEX = exports.UNSIGNED_METADATA_BYTE_SIZE_BS = exports.DATA_PACKAGES_COUNT_BS = exports.DEFAULT_NUM_VALUE_DECIMALS = exports.DEFAULT_NUM_VALUE_BS = exports.DATA_POINT_VALUE_BYTE_SIZE_BS = exports.DATA_POINTS_COUNT_BS = exports.TIMESTAMP_BS = void 0;
exports.TIMESTAMP_BS = 6;
exports.DATA_POINTS_COUNT_BS = 3;
exports.DATA_POINT_VALUE_BYTE_SIZE_BS = 4;
exports.DEFAULT_NUM_VALUE_BS = 32;
exports.DEFAULT_NUM_VALUE_DECIMALS = 8;
exports.DATA_PACKAGES_COUNT_BS = 2;
exports.UNSIGNED_METADATA_BYTE_SIZE_BS = 3;
exports.REDSTONE_MARKER_HEX = "0x000002ed57011e0000";
exports.REDSTONE_MARKER_BS = exports.REDSTONE_MARKER_HEX.length / 2 - 1;
exports.SIGNATURE_BS = 65;
exports.DATA_FEED_ID_BS = 32;
exports.ALL_FEEDS_KEY = "___ALL_FEEDS___";
//# sourceMappingURL=redstone-constants.js.map